import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "p-3" }
const _hoisted_4 = { class: "block text-slate-400 font-semibold text-sm" }
const _hoisted_5 = { class: "mt-3 font-bold text-lg pb-4 border-b border-slate-300 h-28" }
const _hoisted_6 = { class: "flex mt-4 mb-3 gap-4 items-center" }
const _hoisted_7 = { class: "flex items-center gap-1" }
const _hoisted_8 = { class: "text-black text-sm" }
const _hoisted_9 = { class: "flex items-center gap-1" }
const _hoisted_10 = { class: "text-black text-sm" }

import { onMounted } from 'vue';
import { useLikes } from '@/composables/useBlogLikes';
import { formatFirebaseTimestamp } from '@/helpers/index';

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  __name: 'BlogItem',
  props: { post: Object },
  setup(__props) {



const { initializeLikes, isLiked, toggleLike } = useLikes();

onMounted(() => {
  initializeLikes();
});

return (_ctx: any,_cache: any) => {
  return (__props.post)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        class: "bg-white shadow rounded-lg overflow-hidden hover:opacity-90 transition-all",
        href: '/blog/' + __props.post.slug
      }, [
        _createElementVNode("img", {
          src: __props.post?.coverImageUrl,
          class: "object-cover h-52 w-full",
          alt: ""
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(formatFirebaseTimestamp)(__props.post?.createdAt)), 1),
          _createElementVNode("h3", _hoisted_5, _toDisplayString(__props.post?.title), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[0] || (_cache[0] = _createElementVNode("i", { class: "pi pi-eye text-black" }, null, -1)),
              _createElementVNode("p", _hoisted_8, _toDisplayString(__props.post?.views ?? 0), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("i", {
                class: _normalizeClass(
              _unref(isLiked)(__props.post.id)
                ? 'pi pi-heart-fill text-red-500'
                : 'pi pi-heart text-black'
            )
              }, null, 2),
              _createElementVNode("p", _hoisted_10, _toDisplayString(__props.post?.likes ?? 0), 1)
            ])
          ])
        ])
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})